import { render, staticRenderFns } from "./ServiceReqReturnReport.vue?vue&type=template&id=6be365b1&scoped=true"
import script from "./ServiceReqReturnReport.vue?vue&type=script&lang=js"
export * from "./ServiceReqReturnReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be365b1",
  null
  
)

export default component.exports